import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const commonRoutes = [
    {
        path: '/login',
        name: 'login',
        component: () => import('../components/Login.vue')
    },
    { path: '/', redirect: '/home' },
]

// 需要通过后台数据来生成的组件
const asyncRoutes = {
    'account_overview': {
        component: () => import('../views/AccountOverview.vue')
    },
    'child_strategy': {
        component: () => import('../views/ChildStrategy.vue')
    },
    'userinfo': {
        component: () => import('../views/UserInfo.vue')
    },
    'history_data': {
        component: () => import('../views/HistoryData.vue')
    },
    'tools_otc_supervisor': {
        component: () => import('../views/ToolsOtcSupervisor.vue')
    },
    'binance_blog_supervisor': {
        component: () => import('../views/BinanceBlogSupervisor.vue')
    },
    'run_report': {
        component: () => import('../views/StrategyReport.vue')
    },
    'run_report_set_up': {
        component: () => import('../views/StrategyReportSetUp.vue')
    },
    'tools_income_supervisor': {
        component: () => import('../views/BinanceIncome.vue')
    },
    'tools_personDriver': {
        component: () => import('../views/personDriver.vue')
    },
    'tools_finalInterface': {
        component: () => import('../views/finalInterface.vue')
    },
    'tools_control_strategy_human': {
        component: () => import('../views/ControlStrategyHuman.vue')
    },
    'tools_control_flexible_strategy': {
        component: () => import('../views/FlexibleStrategy.vue')
    },
}

function bestCopyEver(src) {
    return Object.assign({}, src);
}

export function setAsyncRoutes(item) {
    var res = {}
    res["component"] = bestCopyEver(asyncRoutes[item.name])["component"]
    res["path"] = item.name + "=" + item.suffix
    res["name"] = item.name + "=" + item.suffix
    //res["params"] = {"suffix":item.suffix}
    return res
}

const createRouter = () => new Router({
    routes: commonRoutes
})

const router = createRouter()

export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher
}

export default router